<div class="stock-modal-backdrop" *ngIf="isVisible" (click)="close()" (keydown.escape)="close()" tabindex="-1"
  aria-hidden="false">
  <section class="stock-modal-panel plan-modal-panel" role="dialog" aria-modal="true"
    aria-labelledby="edit-stock-modal-title" [attr.aria-busy]="uploading || loadingDetail ? 'true' : 'false'"
    (click)="$event.stopPropagation()">
    <div class="modal-layout plan-layout">
      <div class="full-width">
        <div class="role-banner admin">
          Chế độ quản trị
        </div>

        <div class="info-header">
          <div>
            <h2 id="edit-stock-modal-title">Cập nhật kế hoạch / kho hàng</h2>
            <p class="sub-text">
              Quản trị nhiều kho, hình ảnh và tổng kết giá trị kho
            </p>
          </div>
        </div>

        <div class="loading-state" *ngIf="loadingDetail">Đang tải dữ liệu kho...</div>
        <div class="error-state" *ngIf="errorMessage">{{ errorMessage }}</div>

        <form class="form-block" [formGroup]="planForm" *ngIf="!loadingDetail">
          <div class="form-row">
            <label class="form-field">
              <span>Tiêu đề</span>
              <input type="text" formControlName="title" [disabled]="uploading" placeholder="Nhập tiêu đề" />
            </label>

            <label class="form-field">
              <span>Tên kho</span>
              <input type="text" formControlName="warehouseName" [disabled]="uploading" placeholder="Nhập tên kho" />
            </label>
          </div>

          <label class="form-field">
            <span>Mô tả chung</span>
            <textarea rows="3" formControlName="description" [disabled]="uploading"
              placeholder="Nhập mô tả chung..."></textarea>
          </label>

          <div class="section-header">
            <h3>Danh sách kho</h3>
          </div>

          <div formArrayName="items" class="item-list">
            <div #itemCard class="item-card"
              [class.highlighted]="highlightedItemId !== null && item.get('id')?.value === highlightedItemId"
              *ngFor="let item of itemControls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
              <div class="item-card-header">
                <h4>Kho {{ i + 1 }} <span class="item-id">#{{ item.get('id')?.value || '—' }}</span></h4>
                <div class="item-header-actions">
                  <div class="item-status">

                    <div class="toggle-field">
                      <input type="checkbox" class="toggle-input" formControlName="isActive" />
                      <span class="toggle-label">

                        <span [class.text-success]="item.get('isActive')?.value">
                          {{ item.get('isActive')?.value ? 'Đang mở bán' : 'Đang khóa ' }}
                        </span>
                      </span>
                    </div>
                  </div>
                  <span class="item-status-separator">|</span>
                  <button type="button" class="ghost-btn small-btn" (click)="removeItem(i)" [disabled]="uploading">
                    Xóa
                  </button>
                </div>
              </div>

              <div class="item-body">
                <div class="item-media">
                  <div class="upload-block">
                    <div class="upload-header">
                      <h5>{{ (activePreviewIndexByItem[i] || 0) + 1 }}/{{ getPreviewItems(i).length }} </h5>

                      <div class="preview-cta">
                        <label class="file-picker" [attr.for]="'file-input-' + i">
                          <span>Thêm ảnh/ Video</span>
                        </label>
                      </div>
                    </div>

                    <input #fileInput class="sr-only" type="file" [id]="'file-input-' + i" multiple
                      accept="image/*,video/*" (change)="onFileSelected($event, i)"
                      [disabled]="uploading || loadingDetail" />

                    <div class="preview-stage" *ngIf="getActivePreview(i) as preview; else noPreview">
                      <div class="preview-media" (swipeleft)="onSwipeLeft(i)" (swiperight)="onSwipeRight(i)">
                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-prev"
                          (click)="onSwipeRight(i)" aria-label="Ảnh trước">
                          ‹
                        </button>

                        <img *ngIf="preview.type.startsWith('image/')" [src]="preview.preview" [alt]="preview.name" />

                        <video *ngIf="preview.type.startsWith('video/')" [src]="preview.preview" controls></video>

                        <button *ngIf="getPreviewItems(i).length > 1" type="button" class="preview-nav preview-nav-next"
                          (click)="onSwipeLeft(i)" aria-label="Ảnh kế tiếp">
                          ›
                        </button>

                        <button *ngIf="preview.removable" type="button" class="thumb-remove"
                          (click)="removeFile(i, activePreviewIndexByItem[i] || 0)" aria-label="Xóa file hiện tại">
                          <span aria-hidden="true">x</span>
                        </button>
                      </div>

                      <div class="preview-dots" *ngIf="getPreviewItems(i).length > 1">
                        <button type="button" class="preview-dot"
                          *ngFor="let p of getPreviewItems(i); let pIndex = index"
                          [class.is-active]="pIndex === activePreviewIndexByItem[i]"
                          (click)="setActivePreview(i, pIndex)" [attr.aria-label]="'Xem ảnh ' + (pIndex + 1)"></button>
                      </div>
                    </div>

                    <ng-template #noPreview>
                      <div class="preview-empty">Kho này chưa có ảnh. Hãy thêm ảnh mới.</div>
                    </ng-template>
                  </div>
                </div>

                <div class="item-fields">
                  <div class="form-row form-row-1">
                    <label class="form-field">
                      <span class="required-label">Tên kho</span>
                      <input type="text" formControlName="name" [disabled]="uploading"
                        placeholder="Ví dụ: Serum Giảm Mụn Thâm" />
                    </label>
                  </div>

                  <div class="form-row form-row-2 form-row-type-unit">
                    <label class="form-field field-type">
                      <span>Loại sản phẩm</span>
                      <input type="text" formControlName="type" [disabled]="uploading"
                        placeholder="Ví dụ: chăm sóc da" />
                    </label>

                    <label class="form-field field-unit">
                      <span>Đơn vị</span>
                      <input type="text" formControlName="unit" [disabled]="uploading" placeholder="sản phẩm / bộ" />
                    </label>
                  </div>

                  <div class="form-row form-row-2 form-row-pricing">
                    <label class="form-field field-retail">
                      <span class="required-label">Giá bán lẻ</span>
                      <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="12" [disabled]="uploading"
                        placeholder="0" [value]="getFormattedItemValue(i, 'retailPrice')"
                        (input)="onFormattedNumberInput($event, i, 'retailPrice')" />
                    </label>

                    <label class="form-field field-quantity">
                      <span class="required-label">Số lượng</span>
                      <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="12" [disabled]="uploading"
                        placeholder="0" [value]="getFormattedItemValue(i, 'quantity')"
                        (input)="onFormattedNumberInput($event, i, 'quantity')" />
                    </label>
                  </div>

                  <div class="form-row form-row-2 form-row-stock-flow">
                    <label class="form-field field-wholesale">
                      <span class="required-label">Tổng nhập sỉ (VNĐ)</span>
                      <input type="text" [disabled]="true" [value]="formatCurrency(getItemWholesale(item))" />
                    </label>

                    <label class="form-field field-sold">
                      <span>Đã bán</span>
                      <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="12" [disabled]="uploading"
                        placeholder="0" [value]="getFormattedItemValue(i, 'soldQty')"
                        (input)="onFormattedNumberInput($event, i, 'soldQty')" />
                    </label>
                  </div>

                  <label class="form-field">
                    <span>Ghi chú</span>
                    <textarea rows="2" formControlName="note" [disabled]="uploading"
                      placeholder="Nhập ghi chú cho kho"></textarea>
                  </label>

                  <div class="item-summary">
                    <div class="summary-chip">
                      <span>Doanh thu bán lẻ</span>
                      <strong>{{ formatCurrency(getItemRevenue(item)) }}</strong>
                    </div>

                    <div class="summary-chip">
                      <span>Vốn nhập</span>
                      <strong>{{ formatCurrency(getItemWholesale(item)) }}</strong>
                    </div>

                    <div class="summary-chip profit">
                      <span>Lợi nhuận</span>
                      <strong>{{ formatCurrency(getItemProfit(item)) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="display: flex; flex-wrap: nowrap; justify-content: center;">
            <button type="button" class="primary-btn add-btn" (click)="addItem()" [disabled]="uploading">
              + Thêm kho
            </button>
          </div>

          <div class="grand-summary">
            <h3>TỔNG KẾT GIÁ TRỊ KHO HÀNG</h3>

            <div class="grand-summary-grid">
              <div class="grand-box">
                <span>Tổng doanh thu</span>
                <strong>{{ formatCurrency(totalRevenue) }}</strong>
              </div>

              <div class="grand-box">
                <span>Tổng vốn nhập</span>
                <strong>{{ formatCurrency(totalWholesale) }}</strong>
              </div>

              <div class="grand-box highlight">
                <span>Tổng lợi nhuận</span>
                <strong>{{ formatCurrency(totalProfit) }}</strong>
              </div>
            </div>
          </div>
        </form>

        <div class="form-actions">
          <button type="button" class="button close-button" (click)="close()" [disabled]="uploading || deleting">
            Đóng
          </button>

          <button type="button" class="button delete-button" (click)="deleteStock()"
            [disabled]="!planForm.get('id')?.value || uploading || loadingDetail || deleting">
            <span *ngIf="!deleting">Xóa</span>
            <span *ngIf="deleting">⏳ Đang xóa...</span>
          </button>

          <button type="button" class="primary-btn" (click)="submit()" [disabled]="!canSubmit()">
            <span *ngIf="!uploading">Lưu kế hoạch</span>
            <span *ngIf="uploading">⏳ Đang lưu...</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>